import {CategoryTabs} from '@learningblocks/storybook-components/lib/GlossaryComponent/CategoryTabs';
import {DetailsBlock} from '@learningblocks/storybook-components/lib/GlossaryComponent/DetailsBlock';
import {ErrorBlock} from '@learningblocks/storybook-components/lib/GlossaryComponent/ErrorBlock';
import {GlossaryListBlock} from '@learningblocks/storybook-components/lib/GlossaryComponent/GlossaryListBlock';
import {GlossaryListing} from '@learningblocks/storybook-components/lib/GlossaryComponent/GlossaryListing';
import {GlossaryLogo} from '@learningblocks/storybook-components/lib/GlossaryComponent/GlossaryLogo';

import {GlossaryDetails} from '@learningblocks/storybook-components/lib/GlossaryComponent/GlossayDetails';
import {SearchBox} from '@learningblocks/storybook-components/lib/GlossaryComponent/SearchBox';
import {SearchIcon} from '@learningblocks/storybook-components/lib/GlossaryComponent/SearchIcon';
import {SearchInput} from '@learningblocks/storybook-components/lib/GlossaryComponent/SearchInput';
import {CategoryDropdown} from '@learningblocks/storybook-components/lib/GlossaryComponent/CategoryDropdown';
import {ChevronIcon} from '@learningblocks/storybook-components/lib/GlossaryComponent/ChevronIcon';
import {IndexCollapsed} from '@learningblocks/storybook-components/lib/GlossaryComponent/IndexCollapsed';
import {MobileIndexBlock} from '@learningblocks/storybook-components/lib/GlossaryComponent/MobileIndexBlock';

export const GlossaryComponent = {
  CategoryDropdown,
  ChevronIcon,
  GlossaryDetails,
  GlossaryLogo,
  GlossaryListing,
  GlossaryListBlock,
  ErrorBlock,
  DetailsBlock,
  CategoryTabs,
  SearchBox,
  SearchIcon,
  SearchInput,
  CategoryDropdown,
  MobileIndexBlock,
  IndexCollapsed,
};
